<template>
  <v-data-table
    dense
    :headers="detectedEventsHeader"
    :items="detectedEventsWithId"
    item-key="localId"
    height="450"
    @click:row="sendEventForVisualizer"
    ><template
      v-for="field in fieldsToDisplay"
      v-slot:[`item.${field}`]="{ item }"
    >
      {{
        getDisplayValueFromPath(item[field], [field], 'AbstractEvent') || 'N/A'
      }}
    </template>

    <template v-slot:[`item.criticity`]="{ item }">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-chip
            class="mt-1 mb-1 mr-2"
            v-on="on"
            :color="item.criticity.color"
            >{{ item.criticity.name }}</v-chip
          >
        </template>
        <span>{{
          item.criticity.customTooltip || item.criticity.defaultTooltip
        }}</span>
      </v-tooltip>
    </template>
    <template v-slot:[`item.alertId`]="{ item }">
      <ScreeningAlertVisualizationDialogue
        :alert="alertIdToAlerts.get(item.alertId)"
    /></template>
  </v-data-table>
</template>

<script>
import dataTools from '../../tools/data.js'
import { v4 as uuid } from 'uuid'

import TLEDecoder from '../../components/Toolbox/TLEDecoder'
import defenseMixin from '../../mixins/defense.js'
import { mapGetters, mapActions } from 'vuex'
import ScreeningCatalogueAnalysisEventsOrbitInsertionVisualizer from './ScreeningCatalogueAnalysisEventsOrbitInsertionVisualizer.vue'
import ScreeningCatalogueAnalysisEventsConjunctionVisualizer from './ScreeningCatalogueAnalysisEventsConjunctionVisualizer.vue'
import ScreeningAlertVisualizationDialogue from './ScreeningAlertVisualizationDialogue.vue'
import ScreeningCatalogueAnalysisEventsManeuverVisualizer from './ScreeningCatalogueAnalysisEventsManeuverVisualizer.vue'

export default {
  name: 'ScreeningCatalogueAnalysisEventsTable',
  mixins: [defenseMixin],
  components: {
    TLEDecoder,
    ScreeningCatalogueAnalysisEventsOrbitInsertionVisualizer,
    ScreeningCatalogueAnalysisEventsConjunctionVisualizer,
    ScreeningAlertVisualizationDialogue,
    ScreeningCatalogueAnalysisEventsManeuverVisualizer
  },
  data() {
    return {
      fieldsToDisplay: [
        'eventType',
        'criticity',
        'eventTargetNoradId',
        'detectionDate',
        'alertId'
      ],
      orbitAfterManeuverCategories: {
        1: {
          fields: [
            { fieldName: 'orbitDateTime', fieldType: 'isoDateTime' },
            { fieldName: 'semiMajorAxis' },
            { fieldName: 'inclination' }
          ],
          noTitle: true
        },
        2: {
          fields: [
            { fieldName: 'eccentricity' },
            { fieldName: 'perigeeArgument' }
          ],
          noTitle: true
        },
        3: {
          fields: [{ fieldName: 'raan' }, { fieldName: 'anomaly' }],
          noTitle: true
        }
      }
    }
  },

  mounted() {},

  props: {
    events: {
      type: Array,
      default: () => []
    },
    idMission: {
      type: String
    }
  },

  computed: {
    ...mapGetters({
      currentResultsLog: 'currentResultsLog'
    }),
    alertIdToAlerts() {
      let mapAlertToId = new Map()
      this.currentResultsLog.results.analysisResult.alertDefinitions.forEach(
        (alert) => mapAlertToId.set(alert.id, alert)
      )
      return mapAlertToId
    },
    detectedEventsHeader() {
      const context = 'AbstractEvent'

      const headers = this.fieldsToDisplay.map((field) =>
        this.getHeaderObjectFromPath([field], context)
      )

      headers.find((header) => header.value === 'criticity')['sort'] = (
        a,
        b
      ) => {
        if (a.priority - b.priority === 0) {
          return a.name < b.name ? -1 : 1
        } else {
          return a.priority - b.priority
        }
      }

      return headers
    },
    detectedEventsWithId() {
      const valuesWithId = []
      for (const event of this.events) {
        valuesWithId.push({ ...event, localId: uuid() })
      }
      return valuesWithId
    }
  },
  methods: {
    ...mapActions(['setDisplayedScreeningEvent', 'setDisplayedScreeningTab']),
    sendEventForVisualizer(item) {
      this.setDisplayedScreeningEvent(item)
      this.setDisplayedScreeningTab(1)
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Roboto');
</style>
